import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { LayoutService } from '../../layout/layout.service';

@Component({
  selector: 'app-menu-toggle',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule],
  templateUrl: './menu-toggle.component.html',
  styleUrl: './menu-toggle.component.scss'
})
export class MenuToggleComponent {
  private layoutService = inject(LayoutService, { optional: true });
  show = !!this.layoutService;

  toggleMenu(): void {
    this.layoutService?.toggleMenu();
  }
}
